import { render, staticRenderFns } from "./legwork.vue?vue&type=template&id=8b87b780&scoped=true"
import script from "./legwork.vue?vue&type=script&lang=js"
export * from "./legwork.vue?vue&type=script&lang=js"
import style0 from "./legwork.vue?vue&type=style&index=0&id=8b87b780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b87b780",
  null
  
)

export default component.exports